// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Link from "../Link.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as TraitName0 from "common/src/tft-static/TraitName0.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Unit");
        }), undefined, (function (v, param, param$1) {
          var match = v.id;
          var rank = match[1];
          var traitId = match[0];
          return React.createElement(Link.make, {
                      route: {
                        TAG: /* Stats */0,
                        _0: {
                          TAG: /* Trait */5,
                          trait: traitId,
                          rank: rank,
                          aperture: param$1.aperture
                        }
                      },
                      children: React.createElement("div", {
                            className: "flex items-center text-sm"
                          }, React.createElement("div", {
                                className: "flex-shrink-0"
                              }, React.createElement(TraitTooltip.make, {
                                    trait: traitId,
                                    rank: rank,
                                    children: React.createElement(TraitImage.PlainIcon2.make, {
                                          traitId: traitId,
                                          rank: rank,
                                          size: 28
                                        })
                                  })), React.createElement("div", {
                                className: "pl-[6px] font-roboto font-normal truncate"
                              }, String(Sd.traitRankUnitCount(traitId, rank, param$1.set)) + " ", React.createElement(TraitName0.make, {
                                    trait: traitId
                                  })))
                    });
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          var match = v.id;
          return param$1.traitsT(match[0]) + String(match[1]);
        }), undefined, 180, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Play rate");
        }), undefined, (function (v, totCount, param) {
          return Global.formatPct(undefined, Global.f(v.count) / Global.f(totCount)) + "%";
        }), undefined, (function (v, param, param$1) {
          return T.humanReadableCount(v.count) + " games";
        }), undefined, (function (v, param, param$1) {
          return v.count;
        }), undefined, 106, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixed(undefined, v.place);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.place;
        }), undefined, 80, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Delta");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixedSign(undefined, v.delta2);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.delta2;
        }), undefined, 80, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Rel. Delta");
        }), undefined, (function (v, param, param$1) {
          return Global.toFixedSign(undefined, v.delta);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.delta;
        }), undefined, 90, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4") + " %";
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct3(v.top4);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.top4;
        }), undefined, 96, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win") + " %";
        }), undefined, (function (v, param, param$1) {
          return Global.formatPct3(v.won);
        }), undefined, undefined, undefined, (function (v, param, param$1) {
          return v.won;
        }), undefined, 80, undefined, undefined)
];

function TraitSynergiesTable(Props) {
  var traits = Props.traits;
  var totCount = Props.totCount;
  var inContext = Props.inContext;
  var scrollRef = Props.scrollRef;
  var data = React.useMemo((function () {
          return Belt_Array.keep(traits, (function (v) {
                        if (v.count >= 100) {
                          return v.count >= (totCount / 1000 | 0);
                        } else {
                          return false;
                        }
                      }));
        }), [
        traits,
        totCount
      ]);
  var keyFn = React.useCallback((function (v) {
          return v.id[0] + String(v.id[1]);
        }), []);
  var tmp = {
    cols: cols,
    data: data,
    context: totCount,
    keyFn: keyFn,
    stickyColCount: 1,
    defaultSortIdx: 1
  };
  var tmp$1 = inContext ? "t52" : undefined;
  if (tmp$1 !== undefined) {
    tmp.top = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Belt_Option.map(scrollRef, (function (el) {
          return [
                  el,
                  200
                ];
        }));
  if (tmp$2 !== undefined) {
    tmp.scrollEl = Caml_option.valFromOption(tmp$2);
  }
  return React.createElement(StatsTable2.make, tmp);
}

var make = TraitSynergiesTable;

export {
  cols ,
  make ,
  
}
/* cols Not a pure module */
